import supabase from '../supabase/supabase';

const CLIENTS_TABLE = 'hostfig_clients_1790769400000';
const PAYMENTS_TABLE = 'hostfig_payments_1790771000000';
const COUNTRIES_TABLE = 'hostfig_countries_1790773000000';

export const FREQUENCY_LABELS = {
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  semi_annual: 'Every 6 Months',
  annual: 'Yearly'
};

const FREQUENCY_MONTHS = { monthly: 1, quarterly: 3, semi_annual: 6, annual: 12 };

// Comprehensive list of countries with currencies for the "Add Country" picker
export const ALL_COUNTRIES = [
  { code: 'AF', name: 'Afghanistan', flag: '🇦🇫', currency_code: 'AFN', currency_symbol: '؋' },
  { code: 'AL', name: 'Albania', flag: '🇦🇱', currency_code: 'ALL', currency_symbol: 'L' },
  { code: 'DZ', name: 'Algeria', flag: '🇩🇿', currency_code: 'DZD', currency_symbol: 'د.ج' },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', currency_code: 'ARS', currency_symbol: '$' },
  { code: 'AU', name: 'Australia', flag: '🇦🇺', currency_code: 'AUD', currency_symbol: 'A$' },
  { code: 'AT', name: 'Austria', flag: '🇦🇹', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'BD', name: 'Bangladesh', flag: '🇧🇩', currency_code: 'BDT', currency_symbol: '৳' },
  { code: 'BE', name: 'Belgium', flag: '🇧🇪', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'BR', name: 'Brazil', flag: '🇧🇷', currency_code: 'BRL', currency_symbol: 'R$' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', currency_code: 'CAD', currency_symbol: 'C$' },
  { code: 'CL', name: 'Chile', flag: '🇨🇱', currency_code: 'CLP', currency_symbol: '$' },
  { code: 'CN', name: 'China', flag: '🇨🇳', currency_code: 'CNY', currency_symbol: '¥' },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴', currency_code: 'COP', currency_symbol: '$' },
  { code: 'CZ', name: 'Czech Republic', flag: '🇨🇿', currency_code: 'CZK', currency_symbol: 'Kč' },
  { code: 'DK', name: 'Denmark', flag: '🇩🇰', currency_code: 'DKK', currency_symbol: 'kr' },
  { code: 'EG', name: 'Egypt', flag: '🇪🇬', currency_code: 'EGP', currency_symbol: 'E£' },
  { code: 'FI', name: 'Finland', flag: '🇫🇮', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'FR', name: 'France', flag: '🇫🇷', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'DE', name: 'Germany', flag: '🇩🇪', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'GH', name: 'Ghana', flag: '🇬🇭', currency_code: 'GHS', currency_symbol: '₵' },
  { code: 'GR', name: 'Greece', flag: '🇬🇷', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'HK', name: 'Hong Kong', flag: '🇭🇰', currency_code: 'HKD', currency_symbol: 'HK$' },
  { code: 'HU', name: 'Hungary', flag: '🇭🇺', currency_code: 'HUF', currency_symbol: 'Ft' },
  { code: 'IN', name: 'India', flag: '🇮🇳', currency_code: 'INR', currency_symbol: '₹' },
  { code: 'ID', name: 'Indonesia', flag: '🇮🇩', currency_code: 'IDR', currency_symbol: 'Rp' },
  { code: 'IE', name: 'Ireland', flag: '🇮🇪', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'IL', name: 'Israel', flag: '🇮🇱', currency_code: 'ILS', currency_symbol: '₪' },
  { code: 'IT', name: 'Italy', flag: '🇮🇹', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'JP', name: 'Japan', flag: '🇯🇵', currency_code: 'JPY', currency_symbol: '¥' },
  { code: 'KE', name: 'Kenya', flag: '🇰🇪', currency_code: 'KES', currency_symbol: 'KSh' },
  { code: 'KR', name: 'South Korea', flag: '🇰🇷', currency_code: 'KRW', currency_symbol: '₩' },
  { code: 'MY', name: 'Malaysia', flag: '🇲🇾', currency_code: 'MYR', currency_symbol: 'RM' },
  { code: 'MX', name: 'Mexico', flag: '🇲🇽', currency_code: 'MXN', currency_symbol: 'Mex$' },
  { code: 'MA', name: 'Morocco', flag: '🇲🇦', currency_code: 'MAD', currency_symbol: 'د.م.' },
  { code: 'NL', name: 'Netherlands', flag: '🇳🇱', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'NZ', name: 'New Zealand', flag: '🇳🇿', currency_code: 'NZD', currency_symbol: 'NZ$' },
  { code: 'NG', name: 'Nigeria', flag: '🇳🇬', currency_code: 'NGN', currency_symbol: '₦' },
  { code: 'NO', name: 'Norway', flag: '🇳🇴', currency_code: 'NOK', currency_symbol: 'kr' },
  { code: 'PK', name: 'Pakistan', flag: '🇵🇰', currency_code: 'PKR', currency_symbol: 'Rs' },
  { code: 'PH', name: 'Philippines', flag: '🇵🇭', currency_code: 'PHP', currency_symbol: '₱' },
  { code: 'PL', name: 'Poland', flag: '🇵🇱', currency_code: 'PLN', currency_symbol: 'zł' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'QA', name: 'Qatar', flag: '🇶🇦', currency_code: 'QAR', currency_symbol: 'ر.ق' },
  { code: 'RU', name: 'Russia', flag: '🇷🇺', currency_code: 'RUB', currency_symbol: '₽' },
  { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', currency_code: 'SAR', currency_symbol: 'ر.س' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', currency_code: 'SGD', currency_symbol: 'S$' },
  { code: 'ZA', name: 'South Africa', flag: '🇿🇦', currency_code: 'ZAR', currency_symbol: 'R' },
  { code: 'ES', name: 'Spain', flag: '🇪🇸', currency_code: 'EUR', currency_symbol: '€' },
  { code: 'LK', name: 'Sri Lanka', flag: '🇱🇰', currency_code: 'LKR', currency_symbol: 'Rs' },
  { code: 'SE', name: 'Sweden', flag: '🇸🇪', currency_code: 'SEK', currency_symbol: 'kr' },
  { code: 'CH', name: 'Switzerland', flag: '🇨🇭', currency_code: 'CHF', currency_symbol: 'CHF' },
  { code: 'TW', name: 'Taiwan', flag: '🇹🇼', currency_code: 'TWD', currency_symbol: 'NT$' },
  { code: 'TH', name: 'Thailand', flag: '🇹🇭', currency_code: 'THB', currency_symbol: '฿' },
  { code: 'TR', name: 'Turkey', flag: '🇹🇷', currency_code: 'TRY', currency_symbol: '₺' },
  { code: 'AE', name: 'UAE', flag: '🇦🇪', currency_code: 'AED', currency_symbol: 'د.إ' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', currency_code: 'GBP', currency_symbol: '£' },
  { code: 'US', name: 'United States', flag: '🇺🇸', currency_code: 'USD', currency_symbol: '$' },
  { code: 'VN', name: 'Vietnam', flag: '🇻🇳', currency_code: 'VND', currency_symbol: '₫' }
];

function localToday() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

export function advanceDueDate(dateString, frequency = 'monthly') {
  const [year, month, day] = dateString.split('-').map(Number);
  const monthsToAdd = FREQUENCY_MONTHS[frequency] || 1;
  const targetMonth = month + monthsToAdd;
  const nextMonth = ((targetMonth - 1) % 12) + 1;
  const nextYear = year + Math.floor((targetMonth - 1) / 12);
  const lastDay = new Date(Date.UTC(nextYear, nextMonth, 0)).getUTCDate();
  return `${nextYear}-${String(nextMonth).padStart(2, '0')}-${String(Math.min(day, lastDay)).padStart(2, '0')}`;
}

export function nextMonthlyDueDate(dateString) {
  return advanceDueDate(dateString, 'monthly');
}

export async function getBillingSession() {
  const { data, error } = await supabase.auth.getUser();
  if (error) throw error;
  return data.user;
}

export async function signInAdmin(password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: 'admin@hostfig.com',
    password
  });
  if (error) throw error;
  if (data.user?.email?.toLowerCase() !== 'admin@hostfig.com') {
    await supabase.auth.signOut();
    throw new Error('This account is not authorized for the admin panel.');
  }
  return data.user;
}

export async function signOutAdmin() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

// --- Clients ---

export async function listClients() {
  const { data, error } = await supabase
    .from(CLIENTS_TABLE)
    .select('id,client_name,phone_number,monthly_amount,currency,billing_frequency,website_url,next_due_date,is_active,is_archived,country')
    .order('next_due_date', { ascending: true });
  if (error) throw error;
  return data;
}

export async function createClientRecord(record) {
  const { error } = await supabase.from(CLIENTS_TABLE).insert(record);
  if (error) throw error;
}

export async function updateClientRecord(id, updates) {
  const { error } = await supabase
    .from(CLIENTS_TABLE)
    .update({ ...updates, updated_at: new Date().toISOString() })
    .eq('id', id);
  if (error) throw error;
}

export async function archiveClient(id) {
  return updateClientRecord(id, { is_archived: true, is_active: false });
}

export async function restoreClient(id) {
  return updateClientRecord(id, { is_archived: false });
}

export async function deleteClient(id) {
  const { error } = await supabase
    .from(CLIENTS_TABLE)
    .delete()
    .eq('id', id)
    .eq('is_archived', true);
  if (error) throw error;
}

// --- Payments ---

export async function logPayment(client) {
  const { error } = await supabase.from(PAYMENTS_TABLE).insert({
    client_id: client.id,
    amount: client.monthly_amount,
    currency: client.currency,
    billing_frequency: client.billing_frequency || 'monthly',
    due_date: client.next_due_date
  });
  if (error) throw error;
}

// --- Countries ---

export async function listCountries() {
  const { data, error } = await supabase
    .from(COUNTRIES_TABLE)
    .select('*')
    .order('name', { ascending: true });
  if (error) throw error;
  return data;
}

export async function addCountry(country) {
  const { error } = await supabase.from(COUNTRIES_TABLE).insert(country);
  if (error) throw error;
}

export async function updateCountry(code, updates) {
  const { error } = await supabase
    .from(COUNTRIES_TABLE)
    .update(updates)
    .eq('code', code);
  if (error) throw error;
}

export async function toggleCountryActive(code, isActive) {
  return updateCountry(code, { is_active: isActive });
}

// --- Exchange Rates ---

let cachedRates = null;
let cachedRatesTime = 0;
const RATES_CACHE_MS = 10 * 60 * 1000; // 10 minutes

export async function fetchExchangeRates() {
  const now = Date.now();
  if (cachedRates && now - cachedRatesTime < RATES_CACHE_MS) {
    return cachedRates;
  }
  try {
    const res = await fetch('https://open.er-api.com/v6/latest/USD');
    if (!res.ok) throw new Error('Failed to fetch rates');
    const json = await res.json();
    if (json.result === 'success' && json.rates) {
      cachedRates = json.rates;
      cachedRatesTime = now;
      return cachedRates;
    }
    throw new Error('Invalid rates response');
  } catch (err) {
    // Return fallback rates if API fails
    const fallback = {
      USD: 1, SGD: 1.34, LKR: 295, EUR: 0.92, GBP: 0.79,
      AUD: 1.53, CAD: 1.36, JPY: 149.5, INR: 83.1, CNY: 7.24,
      MYR: 4.47, THB: 35.2, IDR: 15650, PHP: 56.1, KRW: 1320,
      HKD: 7.82, TWD: 31.8, NZD: 1.63, CHF: 0.88, SEK: 10.4,
      NOK: 10.6, DKK: 6.87, PLN: 3.98, CZK: 22.8, HUF: 355,
      TRY: 32.5, BRL: 4.97, MXN: 17.1, ARS: 870, CLP: 935,
      COP: 3950, ZAR: 18.2, NGN: 1550, KES: 129, GHS: 15.5,
      EGP: 48.5, MAD: 9.9, SAR: 3.75, AED: 3.67, QAR: 3.64,
      ILS: 3.65, RUB: 89, PKR: 278, BDT: 117, VND: 24800,
      AFN: 70.5, ALL: 93, DZD: 134
    };
    cachedRates = fallback;
    cachedRatesTime = now;
    return fallback;
  }
}

export function convertCurrency(amount, fromCurrency, toCurrency, rates) {
  if (fromCurrency === toCurrency) return amount;
  const fromRate = rates[fromCurrency] || 1;
  const toRate = rates[toCurrency] || 1;
  return (amount / fromRate) * toRate;
}

// --- Reports ---

function allocationForMonth(payment, year, month) {
  const [dueYear, dueMonth] = payment.due_date.split('-').map(Number);
  const monthOffset = (year - dueYear) * 12 + month - dueMonth;
  const duration = FREQUENCY_MONTHS[payment.billing_frequency] || 1;
  if (monthOffset < 0 || monthOffset >= duration) return null;

  // Allocate cents so every month is accurate and all allocations sum to the payment.
  const cents = Math.round(Number(payment.amount) * 100);
  const base = Math.floor(cents / duration);
  const allocatedCents = base + (monthOffset < cents % duration ? 1 : 0);
  return allocatedCents / 100;
}

export async function getReportData(year, month, countryFilter = 'all') {
  const nextMonth = month === 12 ? 1 : month + 1;
  const nextYear = month === 12 ? year + 1 : year;
  const endDate = `${nextYear}-${String(nextMonth).padStart(2, '0')}-01`;
  const earliestDueDate = `${year - 1}-${String(month).padStart(2, '0')}-01`;

  // Include payments made by the end of the selected month, including advance
  // payments from earlier months whose coverage reaches this month.
  const { data: payments, error: payErr } = await supabase
    .from(PAYMENTS_TABLE)
    .select('*')
    .gte('due_date', earliestDueDate)
    .lt('due_date', endDate)
    .lt('paid_at', endDate)
    .order('paid_at', { ascending: false });
  if (payErr) throw payErr;

  const { data: clients, error: cliErr } = await supabase
    .from(CLIENTS_TABLE)
    .select('id,client_name,phone_number,monthly_amount,currency,billing_frequency,next_due_date,is_active,is_archived,country');
  if (cliErr) throw cliErr;

  const activeClients = (clients || []).filter(c => !c.is_archived);
  const clientMap = {};
  activeClients.forEach(c => { clientMap[c.id] = c; });

  let enrichedPayments = (payments || [])
    .filter(p => clientMap[p.client_id])
    .map(p => {
      const allocatedAmount = allocationForMonth(p, year, month);
      return allocatedAmount === null ? null : {
        ...p,
        amount: allocatedAmount,
        originalAmount: Number(p.amount),
        client_name: clientMap[p.client_id].client_name,
        phone_number: clientMap[p.client_id].phone_number || '',
        country: clientMap[p.client_id].country || 'SG'
      };
    })
    .filter(Boolean);

  let filteredClients = activeClients;

  if (countryFilter !== 'all') {
    enrichedPayments = enrichedPayments.filter(p => p.country === countryFilter);
    filteredClients = activeClients.filter(c => c.country === countryFilter);
  }

  const totalCollected = enrichedPayments.reduce((s, p) => s + Number(p.amount), 0);

  const today = localToday();
  const outstanding = filteredClients.filter(c => {
    if (!c.is_active) return false;
    const [y, m] = c.next_due_date.split('-').map(Number);
    return y === year && m === month && c.next_due_date <= today;
  });
  const totalOutstanding = outstanding.reduce((s, c) => s + Number(c.monthly_amount), 0);

  const overdue = filteredClients.filter(c => c.is_active && c.next_due_date < today);
  const totalOverdue = overdue.reduce((s, c) => s + Number(c.monthly_amount), 0);

  const overdueWithDays = overdue.map(c => {
    const due = new Date(c.next_due_date + 'T00:00:00');
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const days = Math.ceil((now - due) / (1000 * 60 * 60 * 24));
    return { ...c, daysOverdue: days };
  }).sort((a, b) => b.daysOverdue - a.daysOverdue);

  const expected = totalCollected + totalOutstanding;
  const collectionRate = expected > 0 ? (totalCollected / expected) * 100 : 0;

  return {
    payments: enrichedPayments,
    totalCollected,
    outstanding,
    totalOutstanding,
    overdue: overdueWithDays,
    totalOverdue,
    collectionRate,
    paymentCount: enrichedPayments.length,
    // Include raw data for client-side currency conversion
    rawPayments: enrichedPayments,
    rawOutstanding: outstanding,
    rawOverdue: overdueWithDays
  };
}

// --- Test Email ---

export async function sendTestEmail() {
  const { data, error } = await supabase.functions.invoke('send-billing-reminders', {
    body: { action: 'test' }
  });
  if (error) throw new Error(error.message || 'Failed to invoke function');
  if (data && !data.success) throw new Error(data.message || 'SMTP delivery failed');
  return data;
}